import React, {useEffect, useState} from 'react'
import ShowLink from "../../../common/ui/show-link";
import DesignDetails from "./design-details";
import {searchPods} from "../../../pod/services/pod-data-service";
import {searchQuotes} from "../../../common/services/quote-data-service";
import _ from 'lodash'
import {addSingleDesign, getSingleDesign, updateSingleDesign} from "../../services/design-data-service";
import ShowDesignDetail from "../common/show-design-detail";
import {useNavigate} from "react-router-dom";
import {searchThemes} from "../../../theme/services/theme-data-service";
import MultipleDesignDetails from "./multiple-design-details";
import {Promise} from "bluebird";
import {addSingleDesignVariant, getSingleDesignVariant} from "../../services/design-variant-data-service";
import {getNextItemKey} from "../../../common/utils/item-key-util";
import {
    ADD_MULTIPLE_DESIGNS_TABS_LIST,
    DEFAULT_ADD_MULTIPLE_DESIGNS_TAB,
    DESIGN_EDITOR_TABS_LIST,
    DESIGN_KEY_PREFIX
} from "../../constants/design.constant";
import {
    prepareImageFileName,
    processApplyTemplateStyle,
    processDesignVariantDetail, processImagesLayer,
    processTextItemsLayer
} from "../../utils/design-variant-util";
import {processDesignVariantStatistics} from "../../utils/design-util";
import {processBackgroundDetails, processVariantBackgroundDetails} from "../../utils/background-util";

const AddMultipleDesigns = () => {
    let navigate = useNavigate();
    const [isEditDesign, setIsEditDesign] = useState(false);
    const [excludeTemplate, setExcludeTemplate] = useState(true);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [initialStep, setInitialStep] = useState(true);
    const [designList, setDesignList] = useState(null);
    const [selectedPod, setSelectedPod] = useState(null);
    const [parentProduct, setParentProduct] = useState(null);
    const [quoteList, setQuoteList] = useState(null);
    const [podList, setPodList] = useState(null);
    const [themeList, setThemeList] = useState(null);

    useEffect(() => {
        getAllPodList();
        getAllThemeList();
    }, [initialStep]);

    const getAllPodList = async () => {
        const podListResult = await searchPods('');
        setPodList(podListResult);
    }

    const getAllThemeList = async () => {
        const themeListResult = await searchThemes('');
        setThemeList(_.orderBy(themeListResult, ['startText']));
    }

    const handleCreateNewDesigns = async () => {
        setSaveInProgress(true);
        const addedNewDesignList = [];

        const newDesignList = [...designList];
        const selectedQuoteList = [...quoteList];
        const selectedQuoteMap = _.keyBy(selectedQuoteList, 'id');

        await Promise.all(
            newDesignList.map(async (newDesignDetail) => {
                if (!newDesignDetail?.id) {
                    const existingVariants = [];

                    const variants = newDesignDetail?.variants;
                    delete newDesignDetail?.variants;

                    const addedDesign: any = await addSingleDesign(newDesignDetail);
                    newDesignDetail.id = addedDesign.id;

                    if (!_.isEmpty(variants)) {
                        await Promise.mapSeries(variants, async variant => {
                            await copyFromDesignVariant(variant, newDesignDetail, existingVariants, selectedQuoteMap[newDesignDetail?.quoteId]);
                        });
                    }

                    newDesignDetail.variants = existingVariants;
                    processDesignVariantStatistics(newDesignDetail);
                    await updateSingleDesign(newDesignDetail);

                    addedNewDesignList.push(newDesignDetail);
                }
            })
        );

        setDesignList(addedNewDesignList);
        setSaveInProgress(false);

        // console.log({addedNewDesignList});

        navigate("/designs");
    }

    const copyFromDesignVariant = async (currentDesignVariant, existingDesignDetail, existingVariants, quoteDetail) => {
        const designVariantDetailData = await getSingleDesignVariant(currentDesignVariant?.id);
        const copiedDesignVariant = _.cloneDeep(designVariantDetailData.data());

        if (excludeTemplate) {
            copiedDesignVariant.images = _.filter(copiedDesignVariant?.images, ['isTemplate', false]);
        }

        const newVariant: any = {};
        newVariant.designId = existingDesignDetail.id;
        newVariant.name = existingDesignDetail.name;
        newVariant.key = getNextItemKey(existingVariants, DESIGN_KEY_PREFIX.VARIANT);
        newVariant.status = 'in-design';

        processDesignVariantDetail(newVariant, existingDesignDetail, quoteDetail, parentProduct);
        processTextItemsLayer(newVariant);
        processApplyTemplateStyle(newVariant, copiedDesignVariant);

        processImagesLayer(newVariant);
        prepareImageFileName(newVariant, existingDesignDetail);

        processVariantBackgroundDetails(newVariant);

        const addedVariant: any = await addSingleDesignVariant(newVariant);
        newVariant.id = addedVariant.id;
        existingVariants.push(newVariant);
    }

    return (
        <>
            <div className="justify-center bg-gray-200 rounded dashboard-container">

                <div className="justify-start p-8">
                    <div className="items-center justify-start w-full mb-4">
                        <div className="flex justify-start items-center">
                            <div className="mr-2">
                                <ShowLink label="Back"
                                          url="/designs"/>
                            </div>

                            <div className="text-xl">Add Multiple Designs</div>

                            {designList?.length > 0 &&
                                <div className="m-2 pl-4">
                                    {!saveInProgress &&
                                        <button
                                            className="button-small bg-green-500 hover:bg-green-200 hover:text-green-700"
                                            onClick={handleCreateNewDesigns}>
                                            Create <span>({designList?.length})</span> Designs
                                        </button>
                                    }

                                    {saveInProgress &&
                                        <button
                                            className="button-small-no-hover bg-gray-400 border-0 cursor-progress"
                                            onClick={() => {
                                            }}>
                                            Saving Designs ...
                                        </button>
                                    }
                                </div>
                            }

                        </div>
                    </div>

                    <div>
                        <MultipleDesignDetails
                            designList={designList}
                            setDesignList={setDesignList}
                            podList={podList}
                            selectedPod={selectedPod}
                            setSelectedPod={setSelectedPod}
                            themeList={themeList}
                            parentProduct={parentProduct}
                            setParentProduct={setParentProduct}
                            quoteList={quoteList}
                            setQuoteList={setQuoteList}
                            setExcludeTemplate={setExcludeTemplate}/>
                    </div>

                </div>

            </div>
        </>
    )
}

export default AddMultipleDesigns
